import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import CustomDatePicker from "../utils/CustomDatePicker";
import dayjs from "dayjs";

const EditDateDialog = ({
  open,
  onClose,
  dateValue,
  onDateChange,
  onSave,
  title,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ m: 2 }}>{title}</DialogTitle>
      <DialogContent>
        <CustomDatePicker
          label="Date"
          name="date"
          value={dateValue || ""}
          onChange={onDateChange}
          gridSize={12}
          gridSx={{ m: 2 }}
          maxDate={dayjs()}
        />
      </DialogContent>
      <DialogActions sx={{ m: 2 }}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary" variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDateDialog;